<template>
    <div>
        <div class="upload-apk-icon" :class="{ 'is-admin': !isAdmin}">
            <div v-if="isAdmin" class="upload-block apk" :class="{ empty: bundleFiles.length === 0 }">
                <img class="remove" v-if="bundleFiles.length" src="../../../components/ApproveDashboard/Images/delete_video_icon.svg" @click="clearBundleFiles" />
                <div class="file-name" v-if="bundleFiles.length">
                    <div class="ellipsis">{{bundleFiles[0].name}}</div>
                </div>

                <div class="example-btn" v-if="!bundleFiles || bundleFiles.length <= 0">
                    <file-upload ref="uploadBundle"
                                 accept=".apk"
                                 input-id="bundleUpload"
                                 v-model="bundleFiles"
                                 @input-file="inputBundleFile"
                                 @input-filter="inputFilter">
                        <button class="upload-btn"><span>Upload APK</span></button>
                    </file-upload>
                </div>
            </div>
            <div class="upload-block icon" :class="{ empty: iconFiles.length === 0 }" v-if="!hideIconUpload">
                <img class="remove" v-if="iconFiles.length" src="../../../components/ApproveDashboard/Images/delete_video_icon.svg" @click="clearIconFiles" style="float: right;" />
                <div class="file-name" v-if="iconFiles.length">
                    <img :src="iconFiles[0].blob" width="100" height="100" @error="replaceByDefault" />
                </div>

                <div class="example-btn" v-if="!iconFiles || iconFiles.length <= 0">
                    <file-upload ref="uploadIcon"
                                 input-id="iconUpload"
                                 v-model="iconFiles"
                                 @input-file="inputIconFile"
                                 @input-filter="inputFilter">
                        <button class="upload-btn"><span>Upload App Icon</span></button>
                    </file-upload>
                    <span class="mandatory">Mandatory</span>
                    <span class="mandatory">(512px X 512px)</span>
                </div>
            </div>
        </div>
        <!--<div class="img-deminsions-error" v-if="showImgDeminsionsError">
            <span>
                icon width and height must be 512px exactly
            </span>
        </div>-->
    </div>
</template>

<script>

    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import VueUploadComponent from 'vue-upload-component';

    var icon_polipop = null;

    export default {
        components: {
            'file-upload': VueUploadComponent
        },
        data() {
            return {
                bundleFiles: [],
                iconFiles: [],
                hideIconUpload: false,
                showImgDeminsionsError: false,
            }
        },
        computed: {
            ...mapGetters([
                'currentPackageBundle',
                'currentPackageBundleIcon',
            ]),

            isAdmin() {
                return _isAdmin;
            }
        },
        mounted() {
            this.$root.$on('bindFileName', this.bindFileName);
            this.$root.$on('bindIconName', this.bindIconName);
            this.$root.$on('clearBundleFiles', this.clearBundleFiles);
            this.$root.$on('clearIconFiles', this.clearIconFiles);
            this.$root.$on('resetBundleAndIconFiles', this.resetBundleAndIconFiles);
        },
        methods: {
            ...mapActions(
                [
                    'uploadCampaignApk',
                    'savePackageBundle',
                    'savePackageBundleIcon',
                    'clearPackageBundle',
                    'clearPackageBundleIcon',
                ]
            ),

            /**
             * Has changed
             * @param  Object|undefined   newFile   Read only
             * @param  Object|undefined   oldFile   Read only
             * @return undefined
             */
            inputBundleFile (newFile, oldFile) {
                if (newFile && !oldFile && !newFile.active) {
                    // Get response data
                    console.log('response', newFile.response)
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status)
                    }
                    this.savePackageBundle(newFile.file).then(() => {
                        // do
                    }).catch((c) => {
                        // do
                    });
                }
            },
            /**
             * Has changed
             * @param  Object|undefined   newFile   Read only
             * @param  Object|undefined   oldFile   Read only
             * @return undefined
             */
            inputIconFile(newFile, oldFile) {
                this.showImgDeminsionsError = false;
                let me = this;
                if (newFile && !oldFile && !newFile.active) {
                    // Get response data
                    console.log('status', newFile)
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status)
                    }

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var img = new Image;
                        img.onload = function () {
                            if (icon_polipop)
                                icon_polipop.destroy();
                            icon_polipop = new Polipop('iconpolipop', {
                                // appendTo: '#ui-id-2',
                                layout: 'popups',
                                insert: 'after',
                                closer: false,
                                click: function (notification, element) {
                                    notification.preventDefault();
                                    notification.stopPropagation();
                                },
                                pool: 5,
                                sticky: true,
                            });
                            if ((img.naturalWidth !== img.naturalHeight) || ((img.naturalWidth !== 512 && img.naturalWidth !== 180))) {

                                icon_polipop.add({
                                    //content: 'Icon width and height must be 512px exactly',
                                    content: 'Icon width and height must be 512px or 180px',
                                    title: 'Error',
                                    type: 'error',
                                });
                                if (validator_polipop) {
                                    var iconp = document.getElementById('iconpolipop');
                                    var validp = document.getElementById('validator_polipop');
                                    if (validp) {
                                        iconp.style.top = 75 + validp.clientHeight + 'px';
                                    }
                                }
                                me.showImgDeminsionsError = true;
                                me.clearIconFiles();
                                return;
                            }
                            me.savePackageBundleIcon(newFile.file).then(() => {
                                // do
                                setIsDirty();
                            }).catch((c) => {
                                // do
                            });
                        };
                        img.src = reader.result;
                    };
                    reader.readAsDataURL(newFile.file);

                }
            },
            /**
             * Pretreatment
             * @param  Object|undefined   newFile   Read and write
             * @param  Object|undefined   oldFile   Read only
             * @param  Function           prevent   Prevent changing
             * @return undefined
             */
            inputFilter (newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Filter non-image file
                    if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                        console.log('non-image file');
                    }
                }

                // Create a blob field
                newFile.blob = '';
                let URL = window.URL || window.webkitURL;
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file);
                }
            },
            clearBundleFiles() {
                this.bundleFiles = [];
                this.clearPackageBundle();
                setIsDirty();
            },
            clearIconFiles() {
                this.iconFiles = [];
                this.clearPackageBundleIcon();
                setIsDirty();
            },
            resetBundleAndIconFiles() {
                this.bundleFiles = [];
                this.clearPackageBundle();
                this.iconFiles = [];
                this.clearPackageBundleIcon();
            },
            bindFileName(fileLocation) {
                console.log(fileLocation)
                this.bundleFiles = [];
                if (fileLocation && fileLocation !== 'null' &&
                    model.current_app_pkg_apk_location.includes('tools/approve_apk')) {
                    const filePathSplitArr = fileLocation.split('/');
                    const fileName = filePathSplitArr[filePathSplitArr.length - 1];
                    this.bundleFiles = [{ name: fileName }];
                }
            },
            bindIconName({ package_icon_name, package_icon_source }) {
                if (package_icon_name && package_icon_name !== 'null') {
                    const iconPath = '//cdn.appnext.com/' + package_icon_source + '/' + package_icon_name;
                    this.iconFiles = [{ name: package_icon_name, blob: iconPath }];
                    this.savePackageBundleIcon({ name: package_icon_name, blob: iconPath }).then(() => {
                        // do
                    }).catch((c) => {
                        // do
                    });
                    //this.hideIconUpload = true;
                } else {
                    //this.hideIconUpload = false;
                }
            },
            replaceByDefault(e) {
                this.clearIconFiles();
                return '';
            }
        }
    }

</script>

<style lang="scss">
    .upload-apk-icon {
        display: flex;
        width: 100%;
        max-width: 682px;

        .upload-block {
            position: relative;
            background: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: 1px solid lightgray;
            border-radius: 8px;
            padding: 15px;
            min-height: 100px;

            &.icon {
                flex: 0 0 25%;
                margin-left: 10px;
            }

            .file-name {
                .ellipsis {
                    max-width: 430px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                img {
                    position: relative;
                    border-radius: 10px;
                }
            }

            img.remove {
                cursor: pointer;
                width: 13px;
                height: 13px;
                right: 3px;
                top: 3px;
                left: auto;
            }
        }

        &.is-admin {
            .upload-block {
                &.icon {
                    flex: 1;
                    margin-left: 0;
                }
            }
        }

        .upload-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 8px 10px;
            background: #FFFFFF;
            border: 1px solid #A1A19F;
            border-radius: 3px;

            span {
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                color: #6C6C6C;
            }
        }

        .example-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 50px;

            .mandatory {
                padding-top: 5px;
                font-size: 13px;
                color: #6B6B6B;
            }

            label {
                cursor: pointer;
            }
        }
    }

    .upload-block.apk.empty, .upload-block.icon.empty {
        border: 1px dashed #B4B4B4;
        background-color: transparent;
    }

    .img-deminsions-error {
        color: #e73232;
        padding: 5px 0;
    }


</style>



// WEBPACK FOOTER //
// src/components/Common/UploadApk/UploadApk.vue